<template>
    <div :class="['manage-slides', { expanded: isExpanded }]" @wheel.passive="handleWheel">
        <div class="action-bar" v-if="!state.isMobile && !state.forceExpandedWorkspace">
            <v-row>
                <v-col cols="12" sm="4">
                    <div class="left"></div>
                </v-col>

                <v-col cols="12" sm="4">
                    <div class="center-buttons">
                        <button class="icon-button rounded wide" @click="toggleHeight">
                            <font-awesome-icon
                                class="mr-2"
                                :style="{
                                    transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                    transition: 'width transform 0.5s',
                                }"
                                icon="fa-regular fa-chevron-up"
                            ></font-awesome-icon>
                            {{ !isExpanded ? 'Explore Themes' : 'Back to Preview' }}
                        </button>
                    </div>
                </v-col>
                <v-col cols="12" sm="4"></v-col>
            </v-row>
        </div>

        <div :class="['slides-container', { expanded: isExpanded }]" ref="templatesWrapper">
            <div :class="['selected-template-wrapper', { expanded: isExpanded }]">
                <template v-if="!loading">
                    <transition name="fade" mode="out-in">
                        <ThemeCard
                            v-if="selectedTemplate.id"
                            :key="selectedTemplate.id"
                            :template="selectedTemplate"
                            :isSelected="true"
                            @edit="openModal"
                            @custom-theme-edit="editCustomTheme"
                            @selectCustom="selectCustomTheme"
                            :disabled="$props.readOnly"
                        >
                            <template v-slot:topRightCorner>
                                <button @click.stop="toggleIntro" class="template-button white-button">
                                    <font-awesome-icon
                                        :icon="[
                                            'fa-regular',
                                            selectedTemplate.title !== 'No Theme' ? 'fa-eye' : 'fa-eye-slash',
                                        ]"
                                    ></font-awesome-icon>
                                </button>
                            </template>
                            <template v-slot:title>
                                Intro
                                <span class="title-append"> ({{ selectedTemplate.title }}) </span>
                            </template>
                        </ThemeCard>
                    </transition>
                    <transition name="fade" mode="out-in">
                        <ThemeCard key="slides" :is-selected="false" :template="{}" @click="changeStep('slides')">
                            <template v-slot:image>
                                <img src="/slides.png" alt="Slides" />
                            </template>
                            <template v-slot:timeslot>
                                {{ formattedSlidesDuration }}
                            </template>
                            <template v-slot:title>
                                Presentation
                                <span class="title-append">
                                    ({{ tributeVideo.totalSlidesCount ?? 0 }}
                                    {{ tributeVideo.totalSlidesCount === 1 ? 'Slide' : 'Slides' }})
                                </span>
                            </template>
                            <template v-slot:actions>&nbsp;</template>
                        </ThemeCard>
                    </transition>
                    <transition name="fade" mode="out-in">
                        <!-- If outro is duplicate of intro... -->
                        <!-- TODO: look into combining this v-if into one card -->
                        <ThemeCard
                            v-if="tributeVideo.replaceOutroSlateWithThemeDuplicate && selectedTemplate.id"
                            :key="selectedTemplate.id"
                            :template="selectedTemplate"
                            :isSelected="true"
                            :disabled="$props.readOnly"
                            :isSet="tributeVideo.outroSlate"
                        >
                            <template v-slot:title>
                                Outro
                                <span
                                    class="title-append"
                                    v-if="tributeVideo.outroSlate && tributeVideo.replaceOutroSlateWithThemeDuplicate"
                                >
                                    ({{ selectedTemplate.title }})
                                </span>
                            </template>
                            <template v-slot:topRightCorner>
                                <button @click.stop="toggleOutroSlate" class="template-button white-button">
                                    <font-awesome-icon
                                        :icon="['fa-regular', tributeVideo.outroSlate ? 'fa-eye' : 'fa-eye-slash']"
                                    ></font-awesome-icon>
                                </button>
                            </template>
                            <template v-slot:actions>
                                <div class="button-group">
                                    <v-menu close-on-click top left>
                                        <template v-slot:activator="{ on, attrs }">
                                            <button v-bind="attrs" v-on="on" class="template-button white-button">
                                                <font-awesome-icon icon="fa-regular fa-pencil"></font-awesome-icon>
                                            </button>
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                :disabled="
                                                    tributeVideo.outroSlate &&
                                                    !tributeVideo.replaceOutroSlateWithThemeDuplicate
                                                "
                                                @click="enableAndSetOutroSlate"
                                            >
                                                <v-list-item-icon>
                                                    <v-icon
                                                        :color="
                                                            tributeVideo.outroSlate &&
                                                            !tributeVideo.replaceOutroSlateWithThemeDuplicate
                                                                ? 'orange'
                                                                : ''
                                                        "
                                                    >
                                                        {{
                                                            tributeVideo.outroSlate &&
                                                            !tributeVideo.replaceOutroSlateWithThemeDuplicate
                                                                ? 'mdi-radiobox-marked'
                                                                : 'mdi-radiobox-blank'
                                                        }}
                                                    </v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-title>Simple Black</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item
                                                :disabled="
                                                    tributeVideo.outroSlate &&
                                                    tributeVideo.replaceOutroSlateWithThemeDuplicate
                                                "
                                                @click="enableAndReplaceOutroSlate"
                                            >
                                                <v-list-item-icon>
                                                    <v-icon
                                                        :color="
                                                            tributeVideo.outroSlate &&
                                                            tributeVideo.replaceOutroSlateWithThemeDuplicate
                                                                ? 'orange'
                                                                : ''
                                                        "
                                                    >
                                                        {{
                                                            tributeVideo.outroSlate &&
                                                            tributeVideo.replaceOutroSlateWithThemeDuplicate
                                                                ? 'mdi-radiobox-marked'
                                                                : 'mdi-radiobox-blank'
                                                        }}
                                                    </v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-title>Duplicate Intro</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item
                                                :disabled="!tributeVideo.outroSlate"
                                                @click="toggleOutroSlate(false)"
                                            >
                                                <v-list-item-icon>
                                                    <v-icon :color="!tributeVideo.outroSlate ? 'orange' : ''">
                                                        {{
                                                            !tributeVideo.outroSlate
                                                                ? 'mdi-radiobox-marked'
                                                                : 'mdi-radiobox-blank'
                                                        }}
                                                    </v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-title>Hidden</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </div>
                            </template>
                        </ThemeCard>
                        <ThemeCard
                            v-else
                            key="outro"
                            :template="{}"
                            :isSelected="false"
                            @custom-theme-edit="editCustomTheme"
                            @selectCustom="selectCustomTheme"
                            :disabled="$props.readOnly"
                            :isSet="tributeVideo?.replaceOutroSlateWithThemeDuplicate || tributeVideo.outroSlate"
                        >
                            <template v-slot:topRightCorner>
                                <button @click.stop="toggleOutroSlate" class="template-button white-button">
                                    <font-awesome-icon
                                        :icon="['fa-regular', tributeVideo.outroSlate ? 'fa-eye' : 'fa-eye-slash']"
                                    ></font-awesome-icon>
                                </button>
                            </template>
                            <template v-slot:image>
                                <video src="/default-outro-preview.webm" muted style="width: 100%"></video>
                            </template>
                            <template v-slot:timeslot>
                                {{ formattedTributeEndingSlateDuration }}
                            </template>
                            <template v-slot:title>
                                Outro
                                <span class="title-append"
                                    >({{
                                        !tributeVideo.replaceOutroSlateWithThemeDuplicate && tributeVideo.outroSlate
                                            ? 'Simple Black'
                                            : 'None'
                                    }})</span
                                >
                            </template>
                            <template v-slot:actions>
                                <div class="button-group">
                                    <v-menu close-on-click top left>
                                        <template v-slot:activator="{ on, attrs }">
                                            <button v-bind="attrs" v-on="on" class="template-button white-button">
                                                <font-awesome-icon icon="fa-regular fa-pencil"></font-awesome-icon>
                                            </button>
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                :disabled="
                                                    tributeVideo.outroSlate &&
                                                    !tributeVideo.replaceOutroSlateWithThemeDuplicate
                                                "
                                                @click="enableAndSetOutroSlate"
                                            >
                                                <v-list-item-icon>
                                                    <v-icon
                                                        :color="
                                                            tributeVideo.outroSlate &&
                                                            !tributeVideo.replaceOutroSlateWithThemeDuplicate
                                                                ? 'orange'
                                                                : ''
                                                        "
                                                    >
                                                        {{
                                                            tributeVideo.outroSlate &&
                                                            !tributeVideo.replaceOutroSlateWithThemeDuplicate
                                                                ? 'mdi-radiobox-marked'
                                                                : 'mdi-radiobox-blank'
                                                        }}
                                                    </v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-title>Simple Black</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item
                                                :disabled="
                                                    tributeVideo.outroSlate &&
                                                    tributeVideo.replaceOutroSlateWithThemeDuplicate
                                                "
                                                @click="enableAndReplaceOutroSlate"
                                            >
                                                <v-list-item-icon>
                                                    <v-icon
                                                        :color="
                                                            tributeVideo.outroSlate &&
                                                            tributeVideo.replaceOutroSlateWithThemeDuplicate
                                                                ? 'orange'
                                                                : ''
                                                        "
                                                    >
                                                        {{
                                                            tributeVideo.outroSlate &&
                                                            tributeVideo.replaceOutroSlateWithThemeDuplicate
                                                                ? 'mdi-radiobox-marked'
                                                                : 'mdi-radiobox-blank'
                                                        }}
                                                    </v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-title>Duplicate Intro</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item
                                                :disabled="!tributeVideo.outroSlate"
                                                @click="toggleOutroSlate(false)"
                                            >
                                                <v-list-item-icon>
                                                    <v-icon :color="!tributeVideo.outroSlate ? 'orange' : ''">
                                                        {{
                                                            !tributeVideo.outroSlate
                                                                ? 'mdi-radiobox-marked'
                                                                : 'mdi-radiobox-blank'
                                                        }}
                                                    </v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-title>Hidden</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </div>
                            </template>
                        </ThemeCard>
                    </transition>
                    <transition name="fade" mode="out-in">
                        <ThemeCard
                            key="brandedOutro"
                            :template="{}"
                            :tributeEndingVideo="tributeVideo.tributeEndingVideo"
                            :disabled="$props.readOnly"
                            :isSet="tributeVideo.outroBrandedVideo && tributeVideo?.tributeEndingVideo"
                        >
                            <template v-slot:timeslot>
                                {{ formattedTributeEndingVideoDuration }}
                            </template>
                            <template v-slot:title>
                                Ending <span class="title-append" v-if="!tributeVideo.outroBrandedVideo">(None)</span>
                            </template>
                            <template v-slot:topRightCorner>
                                <button @click.stop="toggleOutroBrandedVideo" class="template-button white-button">
                                    <font-awesome-icon
                                        :icon="[
                                            'fa-regular',
                                            tributeVideo.outroBrandedVideo ? 'fa-eye' : 'fa-eye-slash',
                                        ]"
                                    ></font-awesome-icon>
                                </button>
                            </template>
                            <template v-slot:actions>
                                &nbsp;
                                <div class="button-group">
                                    <button
                                        @click.stop="$root.$emit('tribute:open-settings-modal')"
                                        class="template-button white-button"
                                    >
                                        <font-awesome-icon icon="fa-regular fa-cog"></font-awesome-icon>
                                    </button>
                                </div>
                            </template>
                        </ThemeCard>
                    </transition>
                </template>
                <template v-else>
                    <div class="slide loading-slide selected"></div>
                    <div class="slide loading-slide selected"></div>
                    <div class="slide loading-slide selected"></div>
                    <div class="slide loading-slide selected"></div>
                </template>
            </div>
            <!-- <div v-else class="templates-wrapper">
            </div> -->

            <div :class="['divider-wrapper', { expanded: isExpanded }]">
                <span :class="['header-text', { expanded: isExpanded }]">Choose your favorite Theme</span>
                <div v-if="selectedTemplate" :class="['divider', { expanded: isExpanded }]"></div>
                <div class="ml-2" v-if="isExpanded">
                    <div class="d-flex">
                        <v-text-field
                            :loading="fetchingTemplates"
                            dense
                            outlined
                            v-model="themeSearch"
                            placeholder="Search Themes"
                            :debounce="250"
                            class="search-field"
                            clearable
                            hide-details
                            @click:clear="
                                () => {
                                    themeSearch = null;
                                    search();
                                }
                            "
                        >
                            <template v-slot:prepend-inner>
                                <font-awesome-icon icon="fa-regular fa-magnifying-glass"></font-awesome-icon>
                            </template>
                        </v-text-field>
                    </div>
                </div>
            </div>

            <transition-group name="slide-animation" tag="div" :class="['templates-wrapper', { expanded: isExpanded }]">
                <!-- <div class="theme-card-wrapper" key="custom-theme-card">
                    <div
                        @click="initThemeBuilderFootageSelect"
                        v-if="!state.isMobile && isExpanded"
                        class="theme-builder-block slide"
                    >
                        <div class="icon-container">
                            <font-awesome-icon
                                class="theme-builder-icon"
                                icon="fa-solid fa-palette"
                            ></font-awesome-icon>
                        </div>
                        <h5 class="font-weight-bold">Theme Builder</h5>
                    </div>
                </div> -->
                <div
                    v-for="(template, index) in orderedTemplates"
                    :key="template.id"
                    class="theme-card-wrapper"
                    ref="templateCards"
                    v-if="!state.isMobile || template.title !== 'Custom Theme'"
                >
                    <ThemeCard
                        :template="template"
                        :isSelected="false"
                        :loading="loading"
                        @select="quickSelectTemplate(tributeVideo.id, template.id)"
                        @selectCustom="selectCustomTheme"
                        :disabled="$props.readOnly"
                    />
                </div>
            </transition-group>
            <!-- <div v-else-if="loading" :class="['templates-wrapper', { expanded: isExpanded }]">
                <div class="loading-slide" v-for="n in 10" :key="n"></div>
            </div>
            <div v-else class="no-results-container">
                <template v-if="themeSearch && themeSearch.length"> No themes matching "{{ themeSearch }}". </template>
                <template v-else>No themes to display.</template>
            </div> -->
        </div>

        <EditTheme
            :isOpen="isModalOpen"
            :tributeId="tributeVideo.id"
            :previewSource="previewSource"
            :currentFont="templateFont"
            :mainPhoto="mainPhotoSource"
            :currentModifications="modifications"
            :loading="updaingTheme"
            @close="closeModal"
            @save="saveCustomTheme"
        />

        <v-dialog v-if="tributeVideo?.funeralHomeId && tributeVideo?.eventId" v-model="showThemeBuilderEditor">
            <CreativeEditor
                @onSave="onEditorSave"
                @close="showThemeBuilderEditor = false"
                @export-progress="val => handleExportProgress(val)"
                @export-start="showProgress = true"
                @export-cancelled="resetProgress"
                @ready="handleEditorReady"
                ref="imglyEditorThemeBuilder"
                :eventId="tributeVideo.eventId"
                :funeralHomeId="tributeVideo.funeralHomeId"
            />
        </v-dialog>

        <StockMediaModal
            :mode="'themeBuilder'"
            @import-to-editor="val => importVideoToThemeBuilderEditor(val)"
            @import-custom-media-to-editor="importCustomMediaToThemeBuilderEditor"
            v-model="showStockMediaModal"
        />

        <SlideUpload
            ref="themeBuilderUploader"
            :maxFiles="1"
            :mediaType="tributeMediaTypeEnum.INTRO"
            videoAllowed
            hidden
            @progress="val => handleUploadProgress(val)"
            @successful-uploads="uploads => handleSuccessfulUploads(uploads)"
        ></SlideUpload>
        <TributeAssetUpload
            ref="themeAssetUploader"
            :maxFiles="1"
            videoAllowed
            hidden
            @progress="val => handleUploadProgress(val)"
            @successful-uploads="handleSuccessfulCustomThemeUpload"
        ></TributeAssetUpload>

        <v-dialog v-model="showProgress" max-width="400px">
            <v-card>
                <v-card-title>
                    <span v-if="progressStage === 'upload'">Uploading..</span>
                    <span v-else>Rendering..</span>
                </v-card-title>

                <v-card-text>
                    <v-progress-linear
                        :color="uploadProgress === 100 ? 'success' : 'primary'"
                        dark
                        height="20"
                        v-if="progressStage === 'upload'"
                        :value="uploadProgress"
                    >
                        {{ uploadProgress }}%
                    </v-progress-linear>
                    <v-progress-linear dark height="20" v-else :value="exportProgress">
                        {{ exportProgress }}%
                    </v-progress-linear>
                </v-card-text>

                <v-card-actions>
                    <v-btn v-if="progressStage === 'export'" depressed class="no-text-transform" @click="cancelExport"
                        >Cancel</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import TributeThemeService from '@/services/tributeTemplate.service';
import TributeVideoService from '@/services/tributeVideo.service';
import TributePhotoService from '@/services/tributePhoto.service';
import BlobService from '@/services/blob.service';
import ThemeCard from './Themes/ThemeCard.vue';
import StockMediaModal from '@/components/Tribute/Modals/StockMediaModal.vue';
import { mapActions } from 'pinia';
import EditTheme from './Themes/EditTheme.vue';
import SlideUpload from '@/components/Tribute/SlideUpload.vue';
import TributeAssetUpload from './TributeAssetUpload.vue';
import { blob2File } from '@/utilities/imageProcessing';
import { withErrorReporting } from '@/utilities/bugsnag-helper';
import { debounce } from 'lodash';
import { tributeMediaTypeEnum } from '../../constants';
import CustomTooltip from '@/components/ui/CustomTooltip.vue';
import { useTributeVideoStore } from '@/stores/tributeVideo';
import { useTributeEditorStore } from '@/stores/tributeEditor';
import { useGlobalState } from '@/stores/globalState';

export default {
    name: 'ManageThemes',
    setup() {
        return {
            tributeVideoStore: useTributeVideoStore(),
            tributeEditor: useTributeEditorStore(),
        };
    },
    components: {
        ThemeCard,
        EditTheme,
        StockMediaModal,
        SlideUpload,
        TributeAssetUpload,
        CreativeEditor: () => import('./Editor/CreativeEditor.vue'),
        CustomTooltip,
    },
    inject: ['state'],
    props: {
        eventId: {
            type: Number,
            required: true,
        },
        tributeVideo: {
            type: Object,
            required: true,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isExpanded: {
            get() {
                return this.tributeEditor.expanded;
            },
        },
        formattedSlidesDuration() {
            return this.tributeVideoStore.formattedSlidesDuration;
        },
        formattedTributeEndingVideoDuration() {
            return this.tributeVideoStore.formattedTributeEndingVideoDuration;
        },
        formattedTributeEndingSlateDuration() {
            return this.tributeVideoStore.formattedTributeEndingSlateDuration;
        },
    },
    watch: {
        themeSearch() {
            this.pageNumber = 0;
            this.debouncedDataFetch();
        },
        filteredTemplates: {
            handler(newTemplates) {
                this.orderedTemplates = [...newTemplates];
                this.templateMap.clear();
                this.templateIndexMap.clear();

                newTemplates.forEach((template, index) => {
                    this.templateMap.set(template.id, template);
                    this.templateIndexMap.set(template.id, index);
                });
            },
            deep: true,
            immediate: true,
        },
        allTemplates: {
            handler(newTemplates) {
                this.filteredTemplates = newTemplates.filter(template => template.id !== this.selectedTemplate?.id);
            },
            deep: true,
            immediate: true,
        },
        selectedTemplate: {
            handler() {
                this.filteredTemplates = this.allTemplates.filter(
                    template => template.id !== this.selectedTemplate?.id,
                );
            },
            immediate: true,
        },
    },

    methods: {
        ...mapActions(useGlobalState, ['showSnackbar', 'block']),
        // ...mapActions('tributeVideo', ['updateTributeVideo', 'updateTributeVideoSelectedTemplates']),
        // ...mapActions('tributeEditor', ['toggleExpandedState']),
        changeStep(val) {
            console.log('change step in manage themes');
            this.$emit('change-step', val);
        },
        async fetchCustomIntroSlide(tributeId) {
            var resp = await this.api.getCustomIntroSlide(tributeId);

            console.log(resp, 'custom intro loaded');

            if (resp?.data) {
                this.customIntroSlide = resp.data;
            }
        },
        async loadCustomThemeInEditor() {
            try {
                this.showThemeBuilderEditor = true;
                await this.$nextTick();

                const editor = this.$refs.imglyEditorThemeBuilder;

                if (!editor) {
                    console.error('editor not found');
                }

                const sceneDataUrl = this.customIntroSlide?.sceneDataURL;
                const slideId = this.customIntroSlide?.id;
                const mediaType = this.customIntroSlide?.mediaType;

                if (!sceneDataUrl) {
                    throw new Error('Scene data not found');
                }

                if (!slideId) {
                    throw new Error('Slide id not found');
                }

                if (!mediaType) {
                    throw new Error('Invalid media type');
                }

                const scene = await this.fetchSceneData(sceneDataUrl);
                if (!scene) {
                    throw new Error('Error fetching scene');
                }

                editor.loadScene(scene, slideId, mediaType);
            } catch (error) {
                console.log(error, 'error loading custom theme');
                this.showThemeBuilderEditor = false;
            }
        },
        async fetchSceneData(sceneDataURL) {
            try {
                const resp = await withErrorReporting(() => {
                    return this.axios.get(sceneDataURL);
                });

                if (resp.data.scene) {
                    return resp.data.scene;
                }

                return null;
            } catch (error) {
                console.log('Error fetching scene data', error);
            }
        },
        editCustomTheme() {
            if (this.customIntroSlide) {
                console.log('CUSTOM THEME FOUND', this.customIntroSlide);

                this.loadCustomThemeInEditor();
            } else {
                console.warn('No custom theme found');
            }
        },
        async selectCustomTheme() {
            if (this.customIntroSlide) {
                this.api.setSlideAsIntro(this.tributeVideo?.id, this.customIntroSlide.id);

                await this.loadSelectedTemplateData();

                await this.fetchCustomIntroSlide(this.tributeVideo.id);
            } else {
                this.initThemeBuilderFootageSelect();
            }
        },
        initThemeBuilderFootageSelect() {
            this.showStockMediaModal = true;
        },
        async handleEditorReady() {
            console.log('editor ready triggered');
            if (!this.importWhenEditorReady) return;

            const baseUrl = this.importWhenEditorReady;
            this.importWhenEditorReady = null;

            setTimeout(async () => {
                await this.$nextTick();

                this.importVideoToThemeBuilderEditor({ link: baseUrl });
            }, 200);
        },

        async importVideoToThemeBuilderEditor(videoData) {
            this.showThemeBuilderEditor = true;
            await this.$nextTick();
            console.log(videoData, 'videoData @ import');
            const baseFootageUrl = videoData.link;
            const duration = videoData?.video?.duration || 120;

            const editor = this.$refs.imglyEditorThemeBuilder;
            if (!editor) {
                console.log('editor not ready, awaiting ready message for import');
                this.importWhenEditorReady = baseFootageUrl;
                // this.showSnackbar({ message: 'Error loading editor', color: 'error' });
                return;
            }

            console.log('editor found; Import starting');
            let dateRange = null;

            if (this.tributeVideo?.birthDate && this.tributeVideo?.deathDate) {
                const birthYear = this.$moment(this.tributeVideo.birthDate).format('YYYY');
                const deathYear = this.$moment(this.tributeVideo.deathDate).format('YYYY');

                dateRange = `${birthYear} - ${deathYear}`;
            }
            let baseUrlType = new RegExp(/(mov|mp4)$/gim).test(baseFootageUrl) ? 'video' : 'photo';

            editor.buildThemeScene({
                baseUrl: baseFootageUrl,
                baseUrlType,
                profilePhotoUrl: this.tributeVideo?.mainPhotoUrl,
                fullName: `${this.tributeVideo?.firstName} ${this.tributeVideo?.lastName}`.trim(),
                dateRange: dateRange,
                duration,
            });
        },
        async importCustomMediaToThemeBuilderEditor() {
            this.showStockMediaModal = false;

            const uploader = this.$refs.themeAssetUploader;
            uploader.openFileSelection();
            this.$watch(
                () => uploader.tempFiles,
                files => {
                    if (files.length) {
                        this.progressStage = 'upload';
                        this.showProgress = true;

                        this.$nextTick(() => {
                            uploader.initUpload(this.$props.eventId);
                        });
                    }
                },
            );
        },
        async onEditorSave(editorResults) {
            const isEditing = editorResults?.slideId && editorResults?.slideId > -1;
            if (isEditing) {
                await this.updateCustomTheme(editorResults);
            } else {
                await this.createAndSetNewCustomTheme(editorResults);
            }
        },
        async updateCustomTheme(editorResults) {
            const { metadata, slideId, scene, blob, keepEditorOpen } = editorResults;
            this.progressStage = 'upload';
            this.showProgress = true;
            this.showThemeBuilderEditor = false;

            blob.name = this.customIntroSlide?.name ?? 'Custom Theme.mp4';
            const { SAS_INFO } = await this.performMediaUpdate(this.$props.eventId, blob);

            await this.photoApi.replacePhoto(slideId, SAS_INFO.fileName, true);
            this.updateSlideScene(slideId, scene);

            this.resetProgress();

            this.showSnackbar({ message: 'Theme update saved' });
        },
        async createAndSetNewCustomTheme(editorResults) {
            const { metadata, scene, blob } = editorResults;
            this.showThemeBuilderEditor = false;

            const fileName = 'Custom Theme.mp4';
            blob.name = fileName;

            const uploader = this.$refs.themeBuilderUploader;

            if (uploader) {
                const file = blob2File(blob, blob.name);
                const uppyId = await uploader.addFile(file);

                console.log(uppyId, 'uppy file added');

                this.pendingCustomThemeUpload = {
                    uppyId,
                    scene,
                };

                this.progressStage = 'upload';

                if (this.eventId) {
                    uploader.initUpload(this.eventId);
                }
            }
        },
        async performMediaUpdate(eventId, file, progressCallback) {
            let { data: SAS_INFO } = await this.photoApi.getUploadUrl(eventId, file);

            await BlobService.upload(SAS_INFO.sas, file, {
                onUploadProgress: progressEvent => {
                    const progress = Math.ceil((progressEvent.loaded / progressEvent.total) * 100);
                    this.handleUploadProgress(progress);
                    if (progressCallback && typeof progressCallback === 'function') {
                        progressCallback(progress);
                    }
                },
            });
            return { SAS_INFO };
        },
        handleUploadProgress(val) {
            if (val > this.uploadProgress) {
                this.uploadProgress = val;
            }
        },
        handleExportProgress(val) {
            if (val > this.exportProgress) {
                this.exportProgress = val;
            }
        },
        resetProgress() {
            this.showProgress = false;

            setTimeout(() => {
                this.progressStage = 'export';
                this.exportProgress = 0;
                this.uploadProgress = 0;
            }, 200);
        },
        async cancelExport() {
            if (this.progressStage !== 'export') return;

            const editor = this.$refs.imglyEditorThemeBuilder;
            if (!editor) return;

            editor.cancelExport();
        },
        async handleSuccessfulUploads(uploads) {
            console.log('successful uploads', uploads);

            if (uploads.length === 0) return;

            const slideId = uploads[0]?.dbData?.id;
            const tributeId = this.tributeVideo?.id;
            const uppyId = uploads[0]?.uppyId;

            let scene;

            if (uppyId && this.pendingCustomThemeUpload.uppyId === uppyId) {
                scene = this.pendingCustomThemeUpload.scene;
            }

            try {
                if (!tributeId) throw new Error('Invalid tributeId');
                if (!slideId) throw new Error('Invalid slideId');
                if (!scene) throw new Error('Scene data not found');

                const [updatedSlideData, resp] = await Promise.all([
                    this.updateSlideScene(slideId, scene),
                    this.api.setSlideAsIntro(tributeId, slideId),
                ]);
            } catch (err) {
                console.log(err, 'Error setting slide as intro');
            } finally {
                this.resetProgress();

                await this.loadSelectedTemplateData();

                await this.fetchCustomIntroSlide(this.tributeVideo.id);
            }
        },
        handleSuccessfulCustomThemeUpload(uploads) {
            console.log('successful uploads', uploads);
            this.showProgress = false;
            if (uploads.length === 0) return;
            this.resetProgress();

            const customVideo = {
                link: uploads[0].dbData.url,
                duration: uploads[0].dbData.duration || 45,
            };
            this.importVideoToThemeBuilderEditor(customVideo);
        },

        async updateSlideScene(slideId, scene) {
            try {
                const resp = await this.photoApi.getSlideSceneUploadUrl(slideId);
                const { sas, fileName } = resp.data;

                const jsonData = {
                    slideId: slideId,
                    lastModified: new Date().toISOString(),
                    scene: scene,
                };

                var sceneBlob = this.generateJsonBlob(jsonData);

                await BlobService.upload(sas, sceneBlob);
                const updatedSlideResp = await this.photoApi.updateSlideScene(slideId, fileName);

                this.tributeVideoStore.updateTributeVideo({
                    // Set lastSyncedChange, in case we need to delay render
                    lastSyncedChange: this.$moment().toISOString(),
                });
                return updatedSlideResp.data;
            } catch (error) {
                console.log('error uploading scene json', error);
            }
        },
        generateJsonBlob(jsonData) {
            const jsonString = JSON.stringify(jsonData);

            const jsonBlob = new Blob([jsonString], { type: 'application/json' });

            return jsonBlob;
        },
        openModal() {
            if (this.isExpanded) this.tributeEditor.toggleExpandedState();
            this.$emit('pause-preview');
            this.isModalOpen = true;
        },

        closeModal() {
            this.isModalOpen = false;
        },
        handleWheel(event) {
            if (event.shiftKey) return;

            if (this.isModalOpen || this.isPreviewModalOpen) return;

            // How much a user needs to scroll before it triggers the expanding behavior
            const wheelBuffer = 80;
            // Access event.deltaY to get the scroll direction and amount
            const direction = event.deltaY > 0 ? 'down' : event.deltaY < 0 ? 'up' : '';
            const distance = Math.abs(event.deltaY);
            // console.log('Mousewheel:', { direction, distance, y: event.deltaY, event});
            // container that overflows the expanded content. Will only trigger a collapse when this is at the top

            const slideContainer = this.$refs.templatesWrapper;
            if (distance > wheelBuffer) {
                if (direction === 'down' && !this.isExpanded) {
                    this.tributeEditor.toggleExpandedState();
                }

                if (
                    direction === 'up' &&
                    this.isExpanded &&
                    slideContainer?.querySelector?.('.templates-wrapper')?.scrollTop < 5
                ) {
                    this.tributeEditor.toggleExpandedState();
                }
            }
        },
        async saveCustomTheme(data) {
            console.log('saveCustomTheme', data);
            try {
                this.updaingTheme = true;
                const { modifications, font, source } = data;
                const duration = Math.round(source.duration);
                const sourceStr = JSON.stringify(source);

                const updatedTemplate = {
                    ...this.selectedTemplate,
                    source: sourceStr,
                    modifications,
                    duration,
                    customFont: font,
                };

                // Keep the original template info as refrence for thumbnail video / title
                // will revisit once adding custom backgrounds
                const reqData = {
                    id: this.selectedTemplate.id,
                    cosmosId: this.selectedTemplate.cosmosId,
                    source: sourceStr,
                    modifications,
                    customFont: font,
                    duration: duration,
                    title: this.selectedTemplate.title,
                    url: this.selectedTemplate.url,
                };

                console.log('setting selectedTemplate', updatedTemplate);
                this.selectedTemplate = updatedTemplate;

                await this.api.updateSelectedTemplates(this.tributeVideo.id, reqData);
                this.updateTributeVideoSelectedTemplates([this.selectedTemplate]);

                await this.refreshSmallPreview(this.tributeVideo.id);
                this.closeModal();
                this.showSnackbar({ message: 'Theme update saved' });
            } catch (error) {
                console.log('error during custom theme save');
                this.showSnackbar({ message: 'Error saving theme update', color: 'error' });
            } finally {
                this.updaingTheme = false;
                this.fetchingTemplates = false;
            }
        },
        updateModificationIds(newModIds, currentModifications) {
            const result = [];

            currentModifications.forEach(mod => {
                const thisMod = newModIds.find(newMod => newMod.name === mod.name);

                if (thisMod) {
                    result.push({
                        ...mod,
                        key: thisMod.creatomateId,
                    });
                }
            });

            return result;
        },
        initializeModifications(templateElements, templateModifications) {
            if (!templateModifications) {
                templateModifications = {};
            }

            const allowedNames = ['name', 'quote', 'main', 'profile', 'date', 'year'];

            this.modifications = templateElements
                .filter(element => element.name && allowedNames.some(term => element.name.toLowerCase().includes(term)))
                .map(element => ({
                    key: element.creatomateId,
                    name: element.name,
                    value: templateModifications[element.creatomateId] || '',
                }));
        },
        formatModsForSaving(changedMods) {
            const mods = changedMods.map(obj => {
                const { name, ...rest } = obj;
                return rest;
            });
            return mods.reduce((acc, obj) => {
                const key = obj.key;
                const value = obj.value;
                acc[key] = value;
                return acc;
            }, {});
        },
        scrollToSelected() {
            this.$nextTick(() => {
                if (this.$refs.templatesWrapper) {
                    this.$refs.templatesWrapper.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth',
                    });
                }
            });
        },
        // Removes any previous chosen font - may need changing
        async quickSelectTemplate(tributeVideoId, templateId) {
            try {
                if (!tributeVideoId) throw new Error('Invalid tribute video id');

                if (!templateId) throw new Error('Invalid template id');

                if (this.isExpanded && !this.state.isMobile) this.tributeEditor.toggleExpandedState();

                this.selectedTemplate = this.templateMap.get(templateId);

                this.scrollToSelected();

                const modsChanged = this.hasCustomModifications(this.defaultModifications, this.modifications);
                const selectedTemplateDetails = await this.api.getTemplate(templateId);
                const tempMods = this.updateModificationIds(
                    selectedTemplateDetails.data.dynamicElements,
                    this.modifications,
                );

                if (modsChanged) {
                    const mods = this.formatModsForSaving(tempMods);
                    const resp = await this.api.selectTemplate(tributeVideoId, templateId, mods);
                    if (resp.data) {
                        this.selectedTemplate = resp.data;
                        this.updateTributeVideoSelectedTemplates([resp.data]);
                        this.initializeModifications(
                            selectedTemplateDetails.data.dynamicElements,
                            this.selectedTemplate.modifications,
                        );
                    }
                } else {
                    const resp = await this.api.selectTemplate(tributeVideoId, templateId);
                    if (resp.data) {
                        this.selectedTemplate = resp.data;
                        this.updateTributeVideoSelectedTemplates([resp.data]);
                        this.modifications = tempMods;
                    }
                }
                await this.refreshSmallPreview(tributeVideoId);

                this.showSnackbar({ message: 'Tribute Theme Updated.' });
                this.$emit('refresh-preview', this.$props.tributeVideo.id);
            } catch (error) {
                this.showSnackbar({ message: 'Unable to save theme.' });
            } finally {
                this.loading = false;
            }
        },

        async refreshSmallPreview(tributeId) {
            const selectedResponse = await this.api.getSelected(tributeId);

            if (selectedResponse?.data?.templates.length > 0) {
                var introTemplate = selectedResponse?.data?.templates[0];

                if (introTemplate.source) {
                    this.previewSource = JSON.parse(introTemplate.source);
                }
                this.templateFont = this.getCurrentFont();
            }
            return;
        },

        toggleHeight() {
            this.tributeEditor.toggleExpandedState();
        },

        getCurrentFont() {
            try {
                if (this.selectedTemplate.customFont) {
                    return this.selectedTemplate.customFont;
                }

                const foundFont = this.previewSource.elements[0].elements.find(
                    el => el.type === 'text' && el.font_family !== '',
                );

                return foundFont
                    ? { family: foundFont.font_family, default: true }
                    : { family: 'default-font', default: true };
            } catch (error) {
                return { family: 'default-font', default: true };
            }
        },
        formatTemplate(rawTemplate) {
            const { id, cosmosId, duration, dynamicElements, staffFavorite, title, url } = rawTemplate;
            return { id, cosmosId, duration, dynamicElements, staffFavorite, title, url };
        },
        updateTemplateData(newTemplates = []) {
            newTemplates.forEach((template, index) => {
                this.templateMap.set(template.id, template);
                this.templateIndexMap.set(template.id, this.orderedTemplates.length + index);
            });

            this.orderedTemplates.splice(this.orderedTemplates.length, 0, ...newTemplates);
        },
        debouncedDataFetch: debounce(function () {
            this.search();
        }, 700),
        async search() {
            // reset pageNumber
            this.pageNumber = 0;
            const templateResults = await this.fetchTemplates();

            if (templateResults?.data?.templates?.length) {
                const results = templateResults.data.templates.map(t => this.formatTemplate(t));
                this.allTemplates = results;
                this.availableTemplates = templateResults.data.total;
            } else {
                this.allTemplates = [];
                this.availableTemplates = 0;
            }
            this.fetchingTemplates = false;
        },
        async fetchTemplates() {
            if (this.fetchingTemplates) {
                return;
            }
            this.fetchingTemplates = true;

            const payload = {
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
            };
            if (this.themeSearch?.length) {
                payload.search = this.themeSearch;
            }
            return this.api.getTemplates(payload);
        },
        async loadMoreTemplates() {
            if (this.allTemplates.length >= this.availableTemplates || this.loading || this.fetchingTemplates) return;

            try {
                this.pageNumber += 1;

                const moreTemplates = await this.fetchTemplates();
                if (moreTemplates?.data?.templates) {
                    const newTemplates = moreTemplates.data.templates.map(t => this.formatTemplate(t));
                    this.allTemplates = [...this.allTemplates, ...newTemplates];

                    this.updateTemplateData(newTemplates);

                    this.$nextTick(() => {
                        if (this.observer) {
                            this.observer.disconnect();
                            this.observeLastTemplate();
                        }
                    });
                }
            } catch (error) {
                this.showSnackbar({ message: 'Unable to load more theme templates' });
            } finally {
                await this.$nextTick();
                this.fetchingTemplates = false;
            }
        },
        hasCustomModifications(obj, array) {
            for (let item of array) {
                const { name, value } = item;
                if (obj.hasOwnProperty(name) && obj[name] !== value) {
                    return true;
                }
            }
            return false;
        },
        setDefaultModifications(tributeVideo) {
            function formatDateToYear(dateString) {
                if (!dateString) return null;
                const date = new Date(dateString);
                const thisDate = date.getFullYear();
                return thisDate.toString();
            }

            const { birthDate, deathDate, firstName, lastName } = tributeVideo;

            if (tributeVideo.mainPhotoUrl !== null && tributeVideo.mainPhotoUrl !== '') {
                this.mainPhotoSource = tributeVideo.mainPhotoUrl;
            } else {
                this.mainPhotoSource = '';
            }

            this.defaultModifications = {
                FirstName: firstName,
                LastName: lastName,
                BirthDate: formatDateToYear(birthDate),
                DeathDate: formatDateToYear(deathDate),
            };
        },
        setupIntersectionObserver() {
            this.$nextTick(() => {
                if (!this.$refs.templatesWrapper || this.allTemplates.length >= this.availableTemplates) {
                    return;
                }
                this.observer = new IntersectionObserver(
                    entries => {
                        const lastEntry = entries[0];

                        // stops observing if all templates are loaded
                        if (this.allTemplates.length >= this.availableTemplates) {
                            this.observer.disconnect();
                            this.observer = null;
                            return;
                        }

                        if (lastEntry.isIntersecting) {
                            this.loadMoreTemplates();
                        }
                    },
                    { root: this.$refs.templatesWrapper.querySelector('.templates-wrapper'), threshold: 0.5 },
                );

                this.observeLastTemplate();
            });
        },

        observeLastTemplate() {
            this.$nextTick(() => {
                const templateElements = this.$refs.templateCards;
                if (templateElements && templateElements.length > 0) {
                    const lastElement = templateElements[templateElements.length - 1];

                    if (this.observer) {
                        this.observer.disconnect(); // prevents re-observing old elements
                    }

                    if (this.allTemplates.length < this.availableTemplates) {
                        this.observer.observe(lastElement);
                    } else {
                        this.observer = null;
                    }
                }
            });
        },
        async setAuthToken() {
            if (this.state.token) {
                this.token = this.state.token;
            } else {
                const tokenClaims = await this.$auth.getIdTokenClaims();
                if (!tokenClaims?.__raw) {
                    this.showSnackbar({ message: 'Unable to retrieve token' });
                }

                this.token = tokenClaims.__raw;
            }
        },
        async loadSelectedTemplateData() {
            if (!this.eventId || !this.tributeVideo?.id) return;

            const selectedResponse = await this.api.getSelected(this.tributeVideo.id);
            const templates = selectedResponse?.data?.templates || [];

            if (!templates.length) {
                console.log('No selected templates returned by the server');
                return;
            }

            this.selectedTemplate = templates[0];

            const [selectedTemplateDetails, allResponse] = await Promise.all([
                this.api.getTemplate(this.selectedTemplate.id),
                this.fetchTemplates(),
            ]);

            if (!allResponse?.data) {
                console.log('No template data returned by the server');
                return;
            }

            this.processTemplateData(allResponse.data);
            await this.refreshSmallPreview(this.tributeVideo.id);

            if (!selectedTemplateDetails?.data?.dynamicElements) {
                this.showSnackbar({ message: 'Error loading some template details' });
                return;
            }

            this.initializeModifications(
                selectedTemplateDetails.data.dynamicElements,
                this.selectedTemplate?.modifications,
            );

            await this.tributeVideoStore.updateTributeVideoSelectedTemplates([this.selectedTemplate]);
            this.setDefaultModifications(this.$props.tributeVideo);

            await this.$nextTick();
            this.fetchingTemplates = false;
        },
        processTemplateData(data) {
            this.availableTemplates = data.total;

            const mappedTemplates = data.templates.map(this.formatTemplate);
            this.allTemplates = mappedTemplates;
            this.orderedTemplates = mappedTemplates;

            this.templateMap.clear();
            this.templateIndexMap.clear();

            mappedTemplates.forEach((template, index) => {
                this.templateMap.set(template.id, template);
                this.templateIndexMap.set(template.id, index);
            });
        },
        async toggleOutroSlate(forcedState) {
            console.log('toggle outro slate');
            const { data } = await this.videoApi.toggleOutroSlate(
                this.tributeVideo.id,
                typeof forcedState === 'boolean' ? !forcedState : this.tributeVideo.outroSlate,
            );
            this.tributeVideoStore.updateTributeVideo({
                ...data,
            });
        },
        async toggleReplaceOutroSlateWithThemeDuplicate() {
            const { data } = await this.videoApi.replaceOutroSlateWithThemeDuplicate(
                this.tributeVideo.id,
                this.tributeVideo.replaceOutroSlateWithThemeDuplicate,
            );
            this.tributeVideoStore.updateTributeVideo({
                ...data,
            });
        },
        async toggleOutroBrandedVideo() {
            const { data } = await this.videoApi.toggleOutroBrandedVideo(
                this.tributeVideo.id,
                this.tributeVideo.outroBrandedVideo,
            );
            this.tributeVideoStore.updateTributeVideo({
                ...data,
            });
        },
        async enableAndSetOutroSlate() {
            // Set replaceOutroSlateWithThemeDuplicate to `true` if not already done
            if (this.tributeVideo.replaceOutroSlateWithThemeDuplicate) {
                await this.toggleReplaceOutroSlateWithThemeDuplicate();
            }
            // Set brandedOutro to `true` if not already
            if (!this.tributeVideo.outroSlate) {
                await this.toggleOutroSlate();
            }
        },
        async enableAndReplaceOutroSlate() {
            // Set brandedOutro to `true` if first (if not already on) to prevent network error on the next call
            if (!this.tributeVideo.outroSlate) {
                await this.toggleOutroSlate();
            }
            // Set replaceOutroSlateWithThemeDuplicate to `true` if not already done
            if (!this.tributeVideo.replaceOutroSlateWithThemeDuplicate) {
                await this.toggleReplaceOutroSlateWithThemeDuplicate();
            }
        },
        async toggleIntro() {
            // If theme is anything other than "No Theme"
            // Check if we have No Theme cached
            // If so, set it as the active theme
            // If not then we search for it by name.

            // Otherwise if theme is "No Theme"
            // Then see if we have the mountain theme cached
            // If so, then set it as the active them
            // If not then search for it by name and then set as active
            if (this.selectedTemplate?.title !== 'No Theme') {
                if (!this.noThemeCache?.id) {
                    const { data: noThemeResults } = await this.api.getTemplates({
                        pageNumber: 0,
                        pageSize: 1,
                        search: 'No Theme',
                    });
                    if (noThemeResults.templates.length) {
                        this.noThemeCache = noThemeResults.templates[0];
                    }
                }
                if (this.noThemeCache?.id) {
                    await this.quickSelectTemplate(this.tributeVideo.id, this.noThemeCache.id);
                }
            } else {
                if (!this.defaultThemeCache?.id) {
                    const { data: defaultThemeResults } = await this.api.getTemplates({
                        pageNumber: 0,
                        pageSize: 1,
                        search: 'Mountain Valley',
                    });
                    if (defaultThemeResults.templates.length) {
                        this.defaultThemeCache = defaultThemeResults.templates[0];
                    }
                }
                if (this.defaultThemeCache?.id) {
                    await this.quickSelectTemplate(this.tributeVideo.id, this.defaultThemeCache.id);
                }
            }
        },
    },
    created() {
        this.debouncedLoadSelectedTemplateData = debounce(this.loadSelectedTemplateData, 500);
    },
    async mounted() {
        try {
            await this.setAuthToken();
            this.api = TributeThemeService(this.token);
            this.videoApi = TributeVideoService(this.token);
            this.photoApi = TributePhotoService(this.token);

            await this.loadSelectedTemplateData();

            await this.fetchCustomIntroSlide(this.tributeVideo.id);
        } catch (error) {
            this.showSnackbar({
                message: 'An error occurred while loading data. Please try again later.',
                color: 'error',
            });
            console.log(error, 'error on manage theme mount');
        } finally {
            this.loading = false;
            this.fetchingTemplates = false;
            this.setupIntersectionObserver();
        }
    },
    beforeUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
    },
    data() {
        return {
            api: null,
            videoApi: null,
            photoApi: null,
            tributeMediaTypeEnum,
            token: null,
            selectedTemplateIndex: 0,
            selectedTemplate: {},
            selectedOutro: {},
            selectedOutroBranded: {},
            allTemplates: [],
            filteredTemplates: [],
            orderedTemplates: [],
            templateMap: new Map(),
            templateIndexMap: new Map(),
            previewSource: {},
            templateFont: {},
            modifications: [],
            defaultModifications: [],
            loading: true,
            isModalOpen: false,
            isPreviewModalOpen: false,
            selectedTemplateForPreview: null,
            pageSize: 24,
            pageNumber: 0,
            availableTemplates: 0,
            mainPhotoSource: '',
            observer: null,
            fetchingTemplates: false,
            themeSearch: null,
            updaingTheme: false,
            showThemeBuilderEditor: false,
            showStockMediaModal: false,
            pendingCustomThemeUpload: {},
            showProgress: false,
            exportProgress: 0,
            uploadProgress: 0,
            progressStage: 'export',
            customIntroSlide: null,
            uploadProgressPercent: 0,
            // loading state for outro syncing
            syncingOutroSlateWithIntro: false,
            noThemeCache: null,
            defaultThemeCache: null,
        };
    },
    sockets: {
        NotifyTributeThemeUpdate(data) {
            if (data?.tributeId && data.tributeId === this.tributeVideo?.id) {
                if (data?.template?.id && this.selectedTemplate.id !== data.template.id) {
                    this.debouncedLoadSelectedTemplateData();
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.manage-slides {
    max-width: 100%;
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    transition: height 0.8s;
    @include mobile() {
        flex-direction: column-reverse;
    }
}

.loading-slide {
    // width: 360px;
    height: 100%;
    max-height: 225px;
    border-radius: 12px;
    position: relative;
    transition: transform 0.2s, border 0.2s;
    flex-shrink: 0;
    display: inline-block;
    background: white;
    border: 1px solid #ccc;
    background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px, #ddd 400px);
    background-size: 200% 100%;
    background-repeat: repeat-x;
    animation: shimmer 1s infinite linear;
    aspect-ratio: 8 / 5;
    flex: 1;
}

@keyframes shimmer {
    0% {
        background-position: -32px;
    }

    40%,
    100% {
        background-position: 360px;
    }
}

.theme-placeholder {
    width: 360px;
    height: 220px;
    border-radius: 6px;
    position: relative;
    gap: 8px;
    padding: 16px;
    flex-shrink: 0;
    display: inline-block;
    background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px, #ddd 400px);
    background-repeat: repeat-x;
    animation: shimmer 1s infinite linear;
}

.action-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    width: 100%;
    max-width: 100%;

    @include mobile() {
        margin-top: 8px;
    }
}

.header-text.expanded {
    display: block;
    margin: 0;
    text-align: left;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.025em;
    text-align: center;
    text-decoration-skip-ink: none;
    color: rgba(107, 114, 128, 1);
    text-transform: uppercase;
    text-wrap-style: balance;
}

.header-text {
    display: none;
}

.icon-button {
    width: 38px;
    height: 38px;
    background: white;
    border: 1px solid #d1d5db;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;

    &.rounded {
        border-radius: 6px !important;
    }

    &.wide {
        width: initial;
        padding: 0 10px;
        font-weight: 500;
    }

    &:hover {
        background-color: $light-gray;
    }
}

.divider {
    display: block;
    width: 2px;
    height: 84px;
    margin: auto 0;
    border: 1px solid #d1d5db;
}

.divider-wrapper {
    display: block;
    align-items: center;
    width: 100%;
    padding-top: 80px;
}

.divider.expanded {
    display: none;
}

.divider-wrapper.expanded {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 20px 0;
    height: 20px;
    justify-content: space-between;
    @include mobile() {
        .header-text {
            text-align: start;
        }
    }
}

.slides-container {
    display: flex;
    flex-wrap: nowrap;
    gap: 16px;
    overflow-x: auto;
    overflow-y: hidden;
    padding-top: 8px;
    height: 100%;
    max-width: 100%;
    width: 100%;
    max-height: 252px;
    transition: height 0.8s;
    scroll-snap-type: x mandatory;
    container: templates / size;
}

.slides-container.expanded {
    flex-wrap: wrap;
    min-height: 0;
    max-height: 100%;
    align-content: flex-start;
    .templates-wrapper {
        overflow-y: auto;
    }
}

.slides-container.expanded .templates-wrapper .slide {
    width: 100%;
    flex-shrink: 1;
    aspect-ratio: 8 / 5;
}

.slides-container.expanded .selected-template-wrapper .slide {
    width: 100%;
    flex-shrink: 1;
    aspect-ratio: 8 / 5;
}

.slides-container {
    max-height: 100%;

    .templates-wrapper,
    .divider-wrapper,
    .selected-template-wrapper {
        // max-height: 100%;
    }
}

.templates-wrapper {
    display: flex;
    gap: 16px;
    flex-wrap: nowrap;
    height: 250px;
    flex: 1 1 auto;
    overflow-x: visible;
    @include mobile() {
        .slide {
            width: min(73vw, 360px);
        }
    }
    border-bottom-left-radius: 10px;
}
.templates-wrapper,
.divider-wrapper {
    display: none;
}

.slides-container:not(.expanded) {
    overflow-x: auto;
}

.templates-wrapper.expanded {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
    max-height: calc(85cqh - 60px);
    width: 100%;
    box-sizing: border-box;
    padding-right: 5px;
    padding-bottom: 30px;

    .loading-slide {
        width: 100%;
    }
}
.selected-template-wrapper {
    gap: 16px;
    height: 100%;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
    align-items: flex-start;
    justify-content: space-between;
    max-height: 90cqh;
    &.expanded {
        height: 15cqh;
    }
    .slide {
        width: -webkit-fill-available;
        max-width: 25cqw;
        display: inline-flex;
        align-self: stretch;
        height: auto;
        max-height: fit-content;
        aspect-ratio: 8 / 5;
    }
    @include mobile() {
        max-height: 30cqh;
        grid-template-columns: 1fr 1fr;
        @include landscape() {
            gap: 6px;
            display: grid;
            grid-template-columns: repeat(minmax(0, 1fr)) !important;
        }

        .slide {
            max-width: 100%;
        }
    }
}
.center-buttons {
    display: flex;
    justify-content: center;
}

// .selected-template-wrapper.expanded {
//     display: grid;
//     // grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
//     grid-template-columns: repeat(auto-fill, minmax(22vw, 1fr));
//     overflow-y: auto;
//     overflow-x: hidden;
//     height: auto;
//     //max-height: 300px;
//     width: 100%;
//     box-sizing: border-box;
//     padding-right: 5px;
//     padding-bottom: 12px;
// }

.templates-wrapper,
.selected-template-wrapper {
    &.expanded {
        @include mobile() {
            @include portrait() {
                grid-template-columns: 1fr 1fr;
            }
            @include landscape() {
                grid-template-columns: 1fr 1fr 1fr 1fr;
            }
        }
    }
}
.templates-wrapper {
    @include landscape() {
        grid-template-columns: 1fr 1fr;
    }
    @include mobile() {
        @include portrait() {
            height: calc(60cqh - 160px);
        }
    }
    &.expanded {
        height: 100%;
        @include mobile() {
            grid-template-columns: repeat(auto-fill, minmax(153px, 1fr));
        }
    }
}
.no-results-container {
    background: darken($light-gray, 5%);
    padding: 1rem;
    text-align: center;
    border-radius: 10px;
    display: flex;
    flex: 1;
    text-align: center;
    font-weight: bold;
    width: 80%;
    justify-content: center;
}

.slides-count-block,
.theme-builder-block {
    padding: 16px;
    border: 1px solid #ccc;
    // border: 2px solid #eeeeee;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
    position: relative;
    cursor: pointer;
    max-height: 100%;
    width: 100%;
    background-color: #f9fafc;
    // border-color: #ff7837;
    // background-color: lighten(#ff7837, 37%);
    // color: #ff530d;

    .icon-container {
        background-color: lighten(#ff7837, 32%);
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
    }
}

.theme-block {
    width: 100%;
    display: inline-flex;
}
.theme-builder-block:hover {
    background-color: #f2f2f2;
    border-color: #ff530d;
    background-color: lighten(#ff7837, 37%);
}

.theme-builder-icon {
    color: #ff530d;
    font-size: 1.8rem;
}

.button-group {
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
}

.template-button {
    width: 38px;
    height: 38px;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: white;
    border: 1px solid #d1d5db;
}

.template-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.white-button {
    background: white;
    border: 1px solid #d1d5db;
}
.intro-append {
    font-weight: normal;
    font-size: 12px;
}
.white-button:hover {
    border-color: #f97316;
}

.white-button:hover svg path {
    stroke: #f97316;
    fill: #f97316;
}

.title-append {
    font-size: 12px;
    font-weight: normal;
}
</style>
